import classNames from 'classnames';
import React from 'react';
import { Col, Layout, Row } from 'antd';
import { Content } from 'antd/es/layout/layout';

import {
  Approvals,
  // Instagram,
  LatestUpdates,
  LeaveBalance,
  // MyTeam,
  // ProfileHealth,
  Reports,
  // TimeCheck,
  TodaySummary,
} from '@Features/DashboardWidgets';

import styles from './dashboard-mobile.module.css';

interface DashboardMobileProps {
  children: JSX.Element;
}

const DashboardMobile: React.FC<DashboardMobileProps> = ({ children }) => {
  return (
    <Layout>
      {children}
      <Content className={styles.container}>
        <Row>
          <Col span={24}>
            <TodaySummary />
          </Col>
        </Row>
        <Row>
          <Col
            span={24}
            className={classNames(
              styles.glassBox,
              'trojan-glassphormism-box trojan-glassphormism-box-shadow'
            )}
          >
            <Approvals />
          </Col>
        </Row>
        {/* <Row>
          <Col
            span={24}
            className={classNames(
              styles.glassBox,
              'trojan-glassphormism-box trojan-glassphormism-box-shadow'
            )}
          >
            <MyTeam />
          </Col>
        </Row> */}
        <Row>
          <Col
            span={24}
            className={classNames(
              styles.glassBox,
              'trojan-glassphormism-box trojan-glassphormism-box-shadow'
            )}
          >
            <Reports />
          </Col>
        </Row>
        <Row>
          <Col
            span={24}
            className={classNames(
              styles.glassBox,
              'trojan-glassphormism-box trojan-glassphormism-box-shadow'
            )}
          >
            <LeaveBalance />
          </Col>
        </Row>
        {/* <Row>
          <Col
            span={24}
            className={classNames(
              styles.glassBox,
              'trojan-glassphormism-box trojan-glassphormism-box-shadow'
            )}
          >
            <ProfileHealth />
          </Col>
        </Row> */}
        {/* <Row>
          <Col
            span={24}
            className={classNames(
              styles.glassBox,
              'trojan-glassphormism-box trojan-glassphormism-box-shadow'
            )}
          >
            <TimeCheck />
          </Col>
        </Row> */}
        <Row>
          <Col
            span={24}
            className={classNames(
              styles.glassBox,
              'trojan-glassphormism-box trojan-glassphormism-box-shadow'
            )}
          >
            <LatestUpdates />
          </Col>
        </Row>
        {/* <Row>
          <Col span={24}>
            <Instagram />
          </Col>
        </Row> */}
      </Content>
    </Layout>
  );
};

export default DashboardMobile;
